import React from 'react'

import './PageHeader.scss'

export default function PageHeader({ title, children, sticky }) {
	return title || children 
		? <header className="PageHeader">
				{ title &&
					<h1>{title}</h1>
				}
				<div className="PageHeader-buttons">
					{ children }
				</div>
			</header>
		: null;
}


// WEBPACK FOOTER //
// ./src/components/PageHeader/PageHeader.jsx